import {gql} from 'apollo-angular';

export const gql_listausuarios = gql`
query($ci:String) {
    lstUsuariosdet(ci:$ci){
        idcarnet
        expedido
        nombres
        appaterno
        apmaterno
        usuario
        clave
        permisos
        theme
        estado
        editar
        jsonunidad
  }
}`;

export const gql_organigrama = gql`
query{
    organigrama{
    text
    value
    checked
    children{
      text
      value
      checked
      children{
        text
        value
        checked
      }
    }
  }
}`;


export const gql_actualizaUsuario = gql`
mutation($datos:RegistroUs){
    actualizaUsuario(input:$datos)
}`;

export const gql_cambiaThema = gql`
mutation($ci:String,$thema:String){
    cambiaThema(ci:$ci,thema:$thema)
}`;

export const gql_sincUserBiotime = gql`
mutation{
  SincUserBiotime
}`;